import React from 'react';
import './pageTransition.css'; // Your CSS file

class PageTransition extends React.Component<{ children: any }> {
    render() {
        let {children} = this.props;
        return (
            <div className="page-animate">
                {children}
            </div>
        );
    }
}

export default PageTransition;
